import i18n from '@/locales';
import { createApp } from 'vue';
import ProjectsByRegionRentalBrowsing from '@/components/rental/ProjectsByRegionRentalBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('ProjectsByRegionRentalBrowsing', ProjectsByRegionRentalBrowsing);
app.mount('#projectsByRegionRentalBrowsingApp');
